import React from 'react';
import { TableRow as New } from './TableRow';
import { convertOldTableRowProps, OldTableRowProps } from './converter.old';

export type TableRowProps = OldTableRowProps;
export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>((props, ref) => (
  <New {...convertOldTableRowProps(props)} ref={ref} />
));

TableRow.displayName = 'TableRow';
